import { render, staticRenderFns } from "./ApplicantPet.vue?vue&type=template&id=77272dcf&scoped=true&"
import script from "./ApplicantPet.vue?vue&type=script&lang=js&"
export * from "./ApplicantPet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77272dcf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
